import CartList from "../components/cart/cartList/CartList";

const Cart = () => {
  return (
    <div className="cart-page">
      <CartList />
    </div>
  );
};
export default Cart;